import { render } from "./ImgUploadM.vue?vue&type=template&id=806cb866"
import script from "./ImgUploadM.vue?vue&type=script&lang=js"
export * from "./ImgUploadM.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__